module.exports = __webpack_public_path__ + "img/icon.00965c20.png";